const globalState = {
    isLogin: false,
    dataProfile: null,
    sidebar: null
}
export {
    globalState
}